import {
    ISearch,
    ISearchProfile,
    ISearchProvider,
    HorizAlignment,
    SearchProviderFieldType,
    ISearchProviderField, ISearchRequestSubset
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch, ISearchRequest} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";
import * as _ from "lodash";
import {PaymentSearch} from "./PaymentSearch";
import {IUsrContext} from "../PA.Core/PA.Core.IF.User";

const ClaimSearch: ISearch = {
    searchName: "Find Claim",
    renderOptions: { ui5ResourceId: "ClaimSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: []
}

function addClaimAuthorizationFilter(findRequest: ISearchRequest): Promise<void> {
    let usrContext: IUsrContext = PAEnvironment.getValue(PAEnvironment.UserContext)
    // Globe Sales Org scope applies regardless of role -- same rule as Events/Plans -- so it
    // runs before the VIEW_ALL short-circuit below, which only bypasses customer-role scoping.
    SearchUtils.addUsrContextSalesOrgFilter(findRequest, 'WB_SALESORG_ID')
    if (usrContext.hasRoleId('VIEW_ALL')) {
        return Promise.resolve()
    }
    SearchUtils.addUsrContextCustomerFilter(findRequest, 'WB_CUST_ID_PLANNING')
    return SearchUtils.addUserGroupCustomerFilter(findRequest, 'WB_CUST_ID_PLANNING')
}

const vUI_Claim_Search_Fields: {[id:string]: ISearchProviderField } = {
    WB_CLM_ID:        {type: SearchProviderFieldType.number, renderOptions: {columnName: 'Claim WB Id', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {}},
    WB_SALESORG_ID:   {type: SearchProviderFieldType.number, renderOptions: {columnName: 'Sales Org Id', columnResourceName: 'colSalesOrgId', alignment: HorizAlignment.Center}, domainOptions: {}},
    CLAIM_ID:         {type: SearchProviderFieldType.string, renderOptions: {columnName: 'Claim ID', columnResourceName: 'colClaimId', alignment: HorizAlignment.Left}, domainOptions: {maxLength: 50}},
    CLAIM_NAME:       {type: SearchProviderFieldType.string, renderOptions: {columnName: 'Claim Name', columnResourceName: 'colClaimName', alignment: HorizAlignment.Left}, domainOptions: {maxLength: 256}},
    CLAIM_COMMENTS:   {type: SearchProviderFieldType.string, renderOptions: {columnName: 'Claim Note', columnResourceName: 'colClaimComments', alignment: HorizAlignment.Left}, domainOptions: {maxLength: 1333}},
    CUSTOMER_NAME:    {type: SearchProviderFieldType.string, renderOptions: {columnName: 'Claim Customer', columnResourceName: 'colCustomer', alignment: HorizAlignment.Left}, domainOptions: {search: ClaimSearch, profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 50}},
    WB_CLMTYPE_ID:    {type: SearchProviderFieldType.number, renderOptions: {columnName: 'Claim Type WB Id', columnResourceName: 'colTypeId', alignment: HorizAlignment.Center},  domainOptions: {}},
    CLAIM_TYPE_NAME:  {type: SearchProviderFieldType.string, renderOptions: {columnName: 'Claim Type', columnResourceName: 'colClaimType', alignment: HorizAlignment.Left}, domainOptions: {search: ClaimSearch, profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 50}},
    WB_CUST_ID_CLAIM: {type: SearchProviderFieldType.number, renderOptions: {columnName: 'Claim Customer WB Id', columnResourceName: 'colClaimCustId', alignment: HorizAlignment.Center}, domainOptions: {}},
    WB_CUST_ID_PLANNING: {type: SearchProviderFieldType.number, renderOptions: {columnName: 'Planning Customer WB Id', columnResourceName: 'colPlanningCustId', alignment: HorizAlignment.Center}, domainOptions: {}},
    PLANNING_CUSTOMER_NAME: {type: SearchProviderFieldType.string, renderOptions: {columnName: 'Planning Customer', columnResourceName: 'colPlanningCustomer', alignment: HorizAlignment.Left}, domainOptions: {search: ClaimSearch, profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 50}},
    REASON_ID:        {type: SearchProviderFieldType.string, renderOptions: {columnName: 'Reason', columnResourceName: 'colReason', alignment: HorizAlignment.Center},  domainOptions: {search: ClaimSearch, profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 50}},
    CUSTOMER_INVOICE: {type: SearchProviderFieldType.string, renderOptions: {columnName: 'Invoice ID', columnResourceName: 'colInvoiceId', alignment: HorizAlignment.Left}, domainOptions: {search: ClaimSearch, profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 256}},
    REFERENCE_ID:     {type: SearchProviderFieldType.string, renderOptions: {columnName: 'Customer Reference Number', columnResourceName: 'colReferenceId', alignment: HorizAlignment.Left}, domainOptions: {search: ClaimSearch, profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 256}},
    CLAIM_DT:         {type: SearchProviderFieldType.string, renderOptions: {columnName: 'Claim Date', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {}},
    CLAIM_AMT:        {type: SearchProviderFieldType.number, renderOptions: {columnName: 'Claim Amount', columnResourceName: 'colId', alignment: HorizAlignment.Right}, domainOptions: {}},
    CURRENCY:         {type: SearchProviderFieldType.string, renderOptions: {columnName: 'Currency', columnResourceName: 'colCurrency', alignment: HorizAlignment.Left}, domainOptions: {maxLength: 50}},
    STATUS_NAME:      {type: SearchProviderFieldType.string, renderOptions: {columnName: 'Claim Status', columnResourceName: 'colClaimStatus', alignment: HorizAlignment.Left}, domainOptions: {search: ClaimSearch, profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 50}},
    CHECK_NO:         {type: SearchProviderFieldType.string, renderOptions: {columnName: 'Check #', columnResourceName: 'colCheck', alignment: HorizAlignment.Center}, domainOptions: {maxLength: 50}},
    SETTLED_AMT:      {type: SearchProviderFieldType.number, renderOptions: {columnName: 'Settlement Amount', columnResourceName: 'colSettleAmt', alignment: HorizAlignment.Right}, domainOptions: {}},
    SETTLED_STATUS:   {type: SearchProviderFieldType.string, renderOptions: {columnName: 'Settlement Status', columnResourceName: 'colSettleStatus', alignment: HorizAlignment.Center}, domainOptions: {search: ClaimSearch, profileId: "default", bUseSearchProvidersDistinctValues: true, maxLength: 50}},
    CREATED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Created Date',
            columnResourceName: 'colCreateDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    },
    MODIFIED_DTTS: {
        type: SearchProviderFieldType.sapdate,
        renderOptions: {
            columnName: 'Modified Date',
            columnResourceName: 'colModifiedDt',
            alignment: HorizAlignment.Center,
            dateFormat: "MM-dd-yy"
        },
        domainOptions: {}
    }
}

const ClaimSearchProviderBasic: ISearchProvider = {

    keyFields: {id:    'WB_CLM_ID',
                id_ui: 'CLAIM_ID',
                name:  'CLAIM_COMMENTS'},


    searchProviderFields: vUI_Claim_Search_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_Claim_Search',
                this.searchProviderFields,
                [])

            addClaimAuthorizationFilter(findRequest)
                .then(() => PASearch.findByRequest(findRequest))
                .then((res: any[]) => {
                    if(res.length > 0) {
                        _.forEach(res, (data) => {
                            data.CLAIM_AMT = _.toNumber(data.CLAIM_AMT)
                        })
                    }
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                })
        })
    },

    distinctValues(fieldName: string): Promise<string[] | number[]> {
        return new Promise<string[] | number[]>((resolve, error) => {
            let findRequest = SearchUtils.makeSearchRequest({},
                'vUI_Claim_Search',
                this.searchProviderFields,
                [fieldName])

            addClaimAuthorizationFilter(findRequest)
                .then(() => PASearch.findByRequest(findRequest))
                .then((res: any[]) => {
                    if(res.length > 0) {
                        _.forEach(res, (data) => {
                            data.CLAIM_AMT = _.toNumber(data.CLAIM_AMT)
                        })
                    }
                    resolve(_.map(res, (aRow) => { return aRow[fieldName] }))
                })
                .catch((err)=> {
                    error(err)
                })
        })
    }

}


const ClaimSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "ClaimSearchProfileByName" },

    profileFilter: [
        {profileFilterName: 'Id',         searchProviderFieldId: 'CLAIM_ID', renderOptions: {}},
        {profileFilterName: 'Name',       searchProviderFieldId: 'CLAIM_NAME', renderOptions: {}},
        {profileFilterName: 'Planning Customer', searchProviderFieldId: 'PLANNING_CUSTOMER_NAME', renderOptions: {}, bMultiSelect: true},
        {profileFilterName: 'Claim Customer',    searchProviderFieldId: 'CUSTOMER_NAME', renderOptions: {}, bMultiSelect: true},
        {profileFilterName: 'Claim Type', searchProviderFieldId: 'CLAIM_TYPE_NAME', renderOptions: {}, bMultiSelect: true},
        {profileFilterName: 'Status',     searchProviderFieldId: 'STATUS_NAME', renderOptions: {}, bMultiSelect: true},
        {profileFilterName: 'Invoice ID', searchProviderFieldId: 'CUSTOMER_INVOICE', renderOptions: {}},
        {profileFilterName: 'Customer Reference Number', searchProviderFieldId: 'REFERENCE_ID', renderOptions: {}},
        // {profileFilterName: 'Claim Date', searchProviderFieldId: 'CLAIM_DT', renderOptions: {}},
    ],  // ISearchFields
    profileDisplayFields: [
        'CLAIM_ID','CLAIM_NAME','CLAIM_TYPE_NAME','CUSTOMER_NAME','PLANNING_CUSTOMER_NAME', 'CLAIM_DT', 'CLAIM_AMT','CURRENCY','STATUS_NAME', 'SETTLED_AMT',
        'CUSTOMER_INVOICE', 'REFERENCE_ID', 'CREATED_DTTS', 'MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: ClaimSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}

ClaimSearch.searchProfiles.push(ClaimSearchProfileByName)

PAEnvironment.registerBusinessObjectSearch("ClaimBO", "Claim", ClaimSearch, "Claim Search")

export {ClaimSearch}
